<div class="bg-secondary">
    <main>
        <div class="container">
            <p>&nbsp;</p>
            <!--Grid row-->
            <div class="row1">
                <b-card>
                    <b-form-group label="UserName/Email" label-for="input-1">
                        <b-form-input id="input-1" v-model="username" disabled></b-form-input>
                    </b-form-group>

                    <b-form-group label="Name" label-for="input-2">
                      <b-form-input id="input-2" v-model="fullName" disabled></b-form-input>
                  </b-form-group>
                  <b-form-group label="Current Whatsapp No" label-for="input-3">
                    <b-form-input id="input-3" v-model="currentWhatsappNumber" disabled></b-form-input>
                </b-form-group>
                <b-form-group label="New Whatsapp No" label-for="input-4">
                  <b-form-input id="input-4" v-model="newWhatsappNumber" ></b-form-input>
              </b-form-group>

                    <b-form-group>
                        <base-button class="btn-1" @click="busy=true" type="primary">Change</base-button>
                    </b-form-group>
                </b-card>
            </div>
            <!--Grid row-->
            <b-overlay :show="busy" no-wrap >
                <template #overlay>
                    <div v-if="processing" class="text-center p-4 bg-primary text-light rounded">
                      <b-icon icon="cloud" font-scale="4"></b-icon>
                      <div class="mb-3">Processing...</div>
                      <div class="text-center">
                        <b-spinner type="grow" label="Spinning"></b-spinner>
                      </div>
                    </div>
                    <div
                      v-else
                      ref="dialog"
                      tabindex="-1"
                      role="dialog"
                      aria-modal="false"
                      aria-labelledby="form-confirm-label"
                      class="text-center p-3"
                    >
                      <p><strong id="form-confirm-label">Are you sure, you want to change whatsapp number?</strong></p>
                      <div class="d-flex">
                        <b-button variant="outline-danger" class="mr-3" @click="onCancel">
                          Cancel
                        </b-button>
                        <b-button variant="outline-success" @click="onOK">OK</b-button>
                      </div>
                    </div>
                  </template>
              </b-overlay>
            <p>&nbsp;</p>
        </div>
    </main>
    <!--Main layout-->
</div>